<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import Link from "svelte-link";
    import { Button } from "sveltestrap";
    import { userName } from "../../store";
    import { useNavigate } from 'svelte-navigator';
    import { Logout } from "../../utils/Constant/Constant";
    const navigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem("Name")
        userName.update(value => value = "null");
        navigate('/login', { replace: true });
        window.location.reload()
    }
</script>

<li class="onhover-dropdown p-0">
    <Button class="btn-primary-light">
        <Link href="/login" target="_self" on:click={handleLogout}>
            <FeatherIcon icon="log-out" />{Logout}
        </Link>
    </Button>
</li>
